import React from 'react';
import { noop } from 'lodash';

// Make sure the shape of the default value passed to
// createContext matches the shape that the consumers expect!
export const CurrentUserContext = React.createContext({
    currentUserId: '',
    setCurrentUserId: noop,
});
